import { Select } from "antd";
import  { forwardRef, useEffect, useState } from "react";
import apiClient from "../../services/api";

const { Option } = Select;

const SelectAjax = forwardRef((props: any, ref) => {
    const [options, setOptions] = useState([]);
    const [hasOptions, setHasOptions] = useState(true);
    const { url, displayProp, valueProp, onNew, value, onChange, disabled: disabledProp, onDisabledChange, ...rest } = props;
  
    const getValues = async () => {
      const res = await apiClient.get(url);
      const data = Array.isArray(res?.data) ? res.data : [];
      setHasOptions(data.length > 0);
      const values = [{ id: "", name: "Selecciona" }, ...data];
      setOptions(values);
    };
  
    useEffect(() => {
      getValues();
    }, [url]);

    useEffect(() => {
      if (onDisabledChange) {
        onDisabledChange(Boolean(disabledProp) || !hasOptions);
      }
    }, [disabledProp, hasOptions, onDisabledChange]);
  
    const handleChange = (val, option) => {
      if (val === "__new__") {
        if (onChange) onChange(undefined);
        if (onNew) onNew();
      } else {
        if (onChange) onChange(val, option);
      }
    };
  
    return (
      <Select
        placeholder="Selecciona"
        allowClear
        showSearch
        disabled={Boolean(disabledProp) || !hasOptions}
        filterOption={(input, option: any) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        value={value}
        onChange={handleChange}
        ref={ref}
        {...rest}
      >
        {options.map((a) => (
          <Option key={a[valueProp] ?? a.id} value={a[valueProp] ?? a.id}>
            {a[displayProp] ?? a.name}
          </Option>
        ))}
        <Option key="__new__" value="__new__">
          + Nuevo
        </Option>
      </Select>
    );
  })
  
  export default SelectAjax ;
